import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'

/* Layout */
import Layout from '@/layout/index.vue'

/* Router modules */
import dashboardRoutes from './modules/dashboard'
import managerRouters from './modules/manager'
import taskRouters from './modules/task'
import productRouters from './modules/product'
import merchantRouters from './modules/merchant'
import orderRouters from './modules/order'
import reportRouters from './modules/report'
import testRouters from './modules/test'
import settingRouters from './modules/setting'
import downloadRouters from './modules/download'
import appRoutes from './modules/app'
// import gcashRouters from './modules/gcash'

import antManageRoutes from './modules/antRouter/antManage'
import antOperateManageRoutes from './modules/antRouter/operateManage'
// import h5OrderRouters from './modules/h5/order'
// import h5TestRouters from './modules/h5/test'

import { isMoment } from 'moment'
Vue.use(Router)

/*
  注意: children.length>=1时才出现子菜单
  细节见: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
*/

/*
  name:'router-name'             在使用<keep-alive>时，name字段是必需的，它还应该匹配其组件的name属性
                                 细节见: https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  redirect:                      如果设置为“noredirect”，当单击面包屑时将不会触发重定向操作
  meta: {
    roles: ['admin', 'editor']   将控制页面角色(允许设置多个角色)
    title: 'title'               在子菜单和面包屑中显示的名称(推荐设置)
    icon: 'svg-name'             图标显示在侧边栏
    hidden: true                 如果为true，此路径将不会显示在侧边栏中(默认为false)
    alwaysShow: true             如果为true，将始终显示根菜单(默认为false)
                                 如果为false，则在子路由少于或等于一个时隐藏根菜单
    breadcrumb: false            如果为false，项目将隐藏在面包屑中(默认为true)
    noCache: true                如果为true，页面将不会被缓存(默认为false)
    affix: true                  如果为true，标签将附着在标签视图中(默认为false)
    activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
  }
*/

export const constantRoutes: RouteConfig[] = [
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () =>
          import(
            /* webpackChunkName: "redirect" */ '@/views/redirect/index.vue'
          )
      }
    ]
  },
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '*',
    component: () =>
      import(/* webpackChunkName: "404" */ '@/views/error-page/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/401',
    component: () =>
      import(/* webpackChunkName: "401" */ '@/views/error-page/401.vue'),
    meta: { hidden: true }
  },
  {
    path: '/enterpriseApp',
    component: () =>
      import(
        /* webpackChunkName: "enterpriseApp" */ '@/views/enterpriseApp/enterpriseApp.vue'
      ),
    meta: { hidden: true }
  },
  {
    path: '/jump',
    name: 'jump',
    component: () =>
      import(/* webpackChunkName: "jump" */ '@/views/jump/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/',
    component: () => import('@/views/redirect/middleware.vue')
  },
  {
    path: '/accountLog',
    name: 'accountLog',
    component: () => import('@/views/product/accountLog.vue'),
    meta: { hidden: true }
  }
]

export const asyncRoutes: RouteConfig[] = [
  dashboardRoutes,
  managerRouters,
  taskRouters,
  productRouters,
  merchantRouters,
  orderRouters,
  reportRouters,
  testRouters,
  settingRouters,
  downloadRouters,
  antManageRoutes,
  appRoutes
  // gcashRouters,
  // antOperateManageRoutes
]

const createRouter = () =>
  new Router({
    mode: 'history', // Disabled due to Github Pages doesn't support this, enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    base: process.env.BASE_URL,
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
    ; (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
